import styled from 'styled-components';
import media from '../../../styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';

let isMobile = isMobileDevice();

export const NavlinksWrapper = styled.div`
    height: auto;
    overflow-y:scroll;
`;

export const NavLinksTopContainer = styled.ul`
    list-style: none;
    display: flex;
    flex-direction: column;
    margin: 0;
    width: 100%;
    font-size: 0.875rem;
    align-items: center;
    padding: ${isMobile ? '0.5rem 0 0 0' : '0'};
    ${media.smalDevice`
        font-family: AvenirNextWorld Bold;
        padding: 0.5rem 0 0 0;
        height: 100%;
        justify-content: space-evenly;
    `}
`;

export const NavLinksBottomContainer = styled.ul`
    list-style: none;
    flex-direction: column;
    margin: 0;
    //padding: ${isMobile ? '0 0 1rem 2rem' : '0'};
    padding: 0;
    width: 100%;
    font-size: 0.875rem;
    align-items: center;
    display: ${isMobile ? 'flex' : 'none'};
    ${media.portraitDevice`
        display: flex;
       // padding: 0 0 1rem 2rem;
        font-family: AvenirNextWorld Bold;
        height: 100%;
        justify-content: space-evenly;
        padding-bottom: 240px; 
    `}

    ${media.mobileDevice`
        padding-bottom: 280px; 
    `}
`;

export const NavLinkStyle = styled.li`
    margin: 0.4rem 0.8rem;
    width: 100%;
    display: flex;
    flex-direction: ${isMobile ? 'row' : 'column'};
    align-items: center;
    text-align: center;

    & a {
        width: 100%;
        border: 1px solid transparent;
        color: #140f4b;
        text-decoration: none;
    }

    ${media.portraitDevice`
        flex-direction: row;
    `}
`;

export const ImgTextCont = styled.div`
    width: ${isMobile ? '100%' : '4.5rem'};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '0.875rem')};
    display: flex;
    flex-direction: ${isMobile ? 'row' : 'column'};
    align-items: center;
    text-align: center;

    border-left: ${(props) =>
        props.leftBorder ? '3px solid #1021EB' : '3px solid transparent'};

    & .moreText {
        color: #140f4b;
        font-family: ${isMobile
            ? 'AvenirNextWorld Bold'
            : 'AvenirNextWorld Demi'};
        font-size: ${isMobile ? '14px' : '10px'};
        ${({ selected }) =>
            selected &&
            `
        color: #1021eb;
        `}
    }

    ${media.portraitDevice`
        flex-direction: row;
        // border: none;
        width: 100%;
        &:hover,
        :active {
          //  border: none;
        }
        padding-left: 25px;

        & .moreText {
            color: #140f4b;
            font-family: 'AvenirNextWorld Bold';
            /* margin: 0 10px; */
            font-size: 14px;
        }
    `}
`;

export const NavText = styled.div`
    margin: 0 10px;
    font-family: ${isMobile ? 'AvenirNextWorld Bold' : 'AvenirNextWorld Demi'};
    font-size: ${isMobile ? '14px' : '10px'};

    ${({ selected }) =>
        selected &&
        `
        color: #1021eb;
        `}
    ${media.portraitDevice`
        font-family: 'AvenirNextWorld Bold';
        color: #140f4b;
        font-size: 14px;
    `}
`;
export const MenuIconContainer = styled.div`
    margin: 0.188rem;
    padding: 0;
    width: 2rem;
    height: 2rem;
`;

export const MenuIconImage = styled.img.attrs((props) => ({
    src: props.defaultImg,
    alt: props.name,
    width: 'auto',
    height: 'auto',
}))`
    ${media.smalDevice`
        display: 'inline-block';
    `}
`;

export const MenuIconActiveImage = styled.img.attrs((props) => ({
    src: props.activeImg,
    alt: props.name,
    width: 'auto',
    height: 'auto',
}))`
    &:hover,
    :active {
        display: 'inline-block';
    }
`;

export const MoreNavLinksContainter = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: 0.875rem;
    display: ${isMobile ? 'block' : 'none'};
    background-color: ${isMobile && '#f5f5f5'};
    // padding: ${isMobile && '0 0 0 3.9rem'};

    ${media.portraitDevice`
        background-color: #f5f5f5;
        font-family: AvenirNextWorld Bold;
        color: #140f4b;
        width: 100%;
        margin: 0;
        //  padding: 0 0 0 3.9rem;
        display: block;
    `}
`;
